import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

  :root {
    --primaryDark: #1f2028;
    --grey: #A9ADC0;
    --darkgrey: #3D3D3D;
    --white: #FFFFFF;
    --red: #FF0000;
    --lightblue: #2ACAEA;
    --black05: rgba(0, 0, 0, 0.5);
    --smoke: #EEEEEE;
    --secondaryBlue: #282c34;
  }
  html {
    background: var(--primaryDark);
    font-size: 10px;
  }
  body {
    font-size: 2rem;
  }
`;

export default GlobalStyles;
